<div class="diagnostic-view-container">
  <app-analytics-card [title]="'ANALYTICS.MOVEMENTS' | translate">
    <div class="time-container">
      <app-analytics-widget [query]="'total-machine-movement-time'" [filters]="filters">
        <ng-template let-result>
          <div class="data-card">
            <app-icam-icon iconName="machine-movement-time" iconHeight="100%" />
            <div class="info">
              <span class="subtitle">{{ 'ANALYTICS.MACHINE_MOVEMENT_TIME' | translate }}</span>
              <span class="value">{{ formatTime(result.rows[0]) }}</span>
            </div>
          </div>
        </ng-template>
      </app-analytics-widget>
      <app-divider [orientation]="'vertical'" class="vertical-divider"></app-divider>
      <app-divider [orientation]="'horizontal'" class="horizontal-divider"></app-divider>
      <app-analytics-widget [query]="'total-machine-startup-time'" [filters]="filters">
        <ng-template let-result>
          <div class="data-card">
            <app-icam-icon iconName="machine-startup-time" iconHeight="100%" />
            <div class="info">
              <span class="subtitle">{{ 'ANALYTICS.MACHINE_STARTUP_TIME' | translate }}</span>
              <span class="value">{{ formatTime(result.rows[0]) }}</span>
            </div>
          </div>
        </ng-template>
      </app-analytics-widget>
    </div>
  </app-analytics-card>
</div>
